module.exports = __webpack_public_path__ + "img/prod-1.32c3450d.png";